import * as actions from "../../actions/actions";
import * as actionTypes from "../../actions/actionTypes";

let React = require("react");

import NounProjectPreviewIcon from "../../components/nounproject-preview-icon";

// new imports
import { connect } from "react-redux";

class HeroPreviewContainer extends React.Component {
    componentDidMount() {
        this.props.setActiveIcon(this.props.icon.id);
        this.setState({ iconLoadedClass: "imgLoaded" });
    }

    componentWillMount() {
        this.fetchSvg(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.setTransparentBG(nextProps.selectedColor.hex);
        this.fetchSvg(nextProps);
        this.userStoreChange();
    }

    constructor(props) {
        super(props);

        let showUpsell = this.shouldSeeUpsell();

        this.state = {
            showUpsell: showUpsell,
            transparentBG: false,
            imgSize: 200,
            iconLoadedClass: ""
        };
    }

    fetchSvg(props) {
        if (this.state.fetchingSvg !== props.icon.id) {
            this.setState({
                fetchingSvg: props.icon.id
            });
            this.props.fetchSVGData(props.icon.icon_url, props.icon.id);
        }
    }

    render() {
        let previewIcon = this.renderPreviewIcon(),
            iconContainerClass = this.renderIconContainerClass(),
            upsell = this.renderUpsell();

        return (
            <div
                className={iconContainerClass.join(" ")}
                style={{ position: "relative" }}
            >
                <div className="icon-box">{previewIcon}</div>
                {upsell}
            </div>
        );
    }

    renderPreviewIcon() {
        let previewIcon;

        if (this.props.activeIcon && this.props.activeIcon.raw_svg) {
            previewIcon = (
                <NounProjectPreviewIcon
                    cleanedSvgCallback={this.saveCleanedSVG.bind(this)}
                    svg={this.props.activeIcon.raw_svg}
                    icon={this.props.activeIcon}
                    imgSize={this.state.imgSize}
                    isEditable={this.props.isEditable}
                    selectedColor={this.props.selectedColor.hex}
                />
            );
        }

        return previewIcon;
    }

    renderIconContainerClass() {
        let iconContainerClass = ["the-icon-container"];
        if (this.state.transparentBG) {
            iconContainerClass.push("updated");
        }

        return iconContainerClass;
    }

    renderUpsell() {
        let upsell,
            upsellActiveClass = ["color-upsell"];

        if (this.state.showUpsell) {
            if (
                this.state.selectedColor !== undefined &&
                this.state.selectedColor !== "#000000" &&
                this.state.selectedColor !== "Black"
            ) {
                // check if a custom color has been selected to show upsell
                upsellActiveClass.push("visible");
            }
            upsell = (
                <div
                    className={upsellActiveClass.join(" ")}
                    style={{
                        maxWidth: "600px",
                        alignItems: "flex-start",
                        width: "100%",
                        padding: "8px 16px",
                        margin: "auto",
                        justifyContent: "space-between",
                        display: "flex",
                        height: "64px",
                        flexDirection: "row",
                        textAlign: "left",
                        background: "rgba(0,0,0,0.75)",
                        zIndex: "2"
                    }}
                >
                    <div
                        className="display-flex"
                        style={{
                            alignItems: "center"
                        }}
                    >
                        <div
                            className="ui_pro-accounts"
                            style={{
                                fontSize: "24px",
                                padding: "8px"
                            }}
                        />
                        <div>
                            <div className="weight-medium">
                                NounPro unlocks all colors, and more
                            </div>
                            <div className="weight-light">
                                only $39.99 billed yearly
                            </div>
                        </div>
                    </div>
                    <a
                        className="display-flex"
                        style={{ alignItems: "center" }}
                        href="#"
                        onClick={this.props.unlockColor}
                    >
                        <span
                            className="text-link weight-medium"
                            style={{
                                color: "#3EA9F5",
                                fontSize: "14px"
                            }}
                        >
                            Get started
                        </span>
                    </a>
                </div>
            );
        }
        return upsell;
    }

    saveCleanedSVG(cleanedSVG) {
        this.cleanedSVG = cleanedSVG;
    }

    setTransparentBG(color) {
        // change preview background to be transparent if not black
        // TODO: change this to just the default black in the future
        color = color.toUpperCase();

        if (color === "BLACK") {
            color = "#000000";
        } else if (color === "#000") {
            color = "#000000";
        }

        let isTransparent = color !== "#000000" ? true : false,
            transitionColor;

        if (this.state.selectedColor === undefined) {
            transitionColor = color;
        } else {
            transitionColor = this.state.selectedColor;
        }

        this.setState({
            transparentBG: isTransparent,
            selectedColor: color,
            transitionColor: transitionColor
        });
    }

    shouldSeeUpsell() {
        if (!this.props.currentUser) {
            return true;
        }

        if (!this.props.currentUser.has_premium_account) {
            return true;
        }
        return false;
    }

    userStoreChange() {
        let showUpsell = this.shouldSeeUpsell();

        this.setState({
            showUpsell: showUpsell
        });
    }
}

function mapStateToProps(state, props) {
    let apiResponse = state.apiResponse,
        activeIcon,
        currentUser,
        colorPalette,
        selectedColor,
        customColorSelected;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    activeIcon = state.icons.active_icon;

    if (state.icons.colorPalette) {
        colorPalette = state.icons.colorPalette;
        if (state.icons.selectedColor) {
            selectedColor = state.icons.selectedColor;
            if (state.icons.selectedColor.hex !== "black") {
                customColorSelected = true;
            } else {
                customColorSelected = false;
            }
        }
    }

    return {
        apiResponse,
        activeIcon,
        currentUser,
        colorPalette,
        selectedColor,
        customColorSelected
    };
}

module.exports = connect(mapStateToProps, {
    fetchSVGData: actions.fetchSVGData,
    setActiveIcon: actions.setActiveIcon
})(HeroPreviewContainer);
